import { Menu, Search, Bell, Plus } from "lucide-react";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { HealthIndicator } from "@/components/common/StatusBadge";
import { TONES } from "@/lib/status";
import { api } from "@/data/api";
import { useAsync } from "@/hooks/useAsync";
import { useNavigate } from "react-router-dom";
const notifications = []; // Notifications backend not implemented.
import { demoAction } from "@/lib/demo";
import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";

// Barra superior: menu mobile, busca (Ctrl+K), status global, notificações, CTA.
export const Topbar = ({ onOpenMobile, onOpenCommand }) => {
  const unread = notifications.length;
  const navigate=useNavigate();
  const status=useAsync(()=>api.getInfraStatus(), [], 20000);
  return (
    <header className="sticky top-0 z-30 flex h-16 items-center gap-3 border-b border-line bg-background/80 px-4 backdrop-blur-xl sm:px-6">
      <button
        onClick={onOpenMobile}
        data-testid="mobile-menu-btn"
        className="flex h-9 w-9 items-center justify-center rounded-lg border border-line text-muted-foreground lg:hidden"
      >
        <Menu className="h-5 w-5" />
      </button>

      {/* Search trigger */}
      <button
        onClick={onOpenCommand}
        data-testid="topbar-search"
        className="group flex h-9 max-w-md flex-1 items-center gap-2 rounded-lg border border-line bg-surface/60 px-3 text-sm text-muted-foreground transition-colors hover:border-line/60 hover:bg-surface"
      >
        <Search className="h-4 w-4" />
        <span className="hidden sm:inline">Buscar...</span>
        <kbd className="ml-auto hidden items-center gap-0.5 rounded border border-line bg-black/30 px-1.5 py-0.5 font-mono text-[10px] sm:inline-flex">Ctrl K</kbd>
      </button>

      <div className="ml-auto flex items-center gap-2 sm:gap-3">
        <HealthIndicator tone={status.data?.ok?"ok":"warn"} label={status.error?"Status indisponível":status.data?.label||"Consultando Agents"} className="hidden md:inline-flex" />

        {/* Notifications */}
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <button data-testid="notifications-btn" className="relative flex h-9 w-9 items-center justify-center rounded-lg border border-line text-muted-foreground transition-colors hover:text-foreground">
              <Bell className="h-[18px] w-[18px]" />
              {unread > 0 && <span className="absolute right-1.5 top-1.5 h-2 w-2 rounded-full bg-brand ring-2 ring-background" />}
            </button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="w-80 border-line bg-popover p-0">
            <div className="flex items-center justify-between border-b border-line px-4 py-3">
              <p className="text-sm font-semibold text-foreground">Notificações</p>
              <span className="rounded-full bg-brand/15 px-2 py-0.5 text-[11px] font-medium text-brand">{unread} novas</span>
            </div>
            <div className="max-h-80 overflow-y-auto">
              <p className="p-4 text-sm text-muted-foreground">Notificações ainda não implementadas.</p>
              {notifications.map((n) => (
                <button
                  key={n.id}
                  onClick={() => demoAction(n.title)}
                  data-testid={`notification-${n.id}`}
                  className="flex w-full items-start gap-3 border-b border-line/60 px-4 py-3 text-left transition-colors last:border-0 hover:bg-white/[0.03]"
                >
                  <span className={cn("mt-1.5 h-2 w-2 shrink-0 rounded-full", TONES[n.tone]?.dot)} />
                  <div className="min-w-0 flex-1">
                    <p className="text-sm font-medium text-foreground">{n.title}</p>
                    <p className="truncate text-xs text-muted-foreground">{n.desc}</p>
                  </div>
                  <span className="shrink-0 text-[11px] text-muted-foreground/70">{n.time}</span>
                </button>
              ))}
            </div>
          </DropdownMenuContent>
        </DropdownMenu>

        <Button onClick={()=>navigate("/projetos")} data-testid="topbar-new-project" className="bg-brand text-white hover:bg-brand-hover">
          <Plus className="h-4 w-4" /> <span className="hidden sm:inline">Novo Projeto</span>
        </Button>
      </div>
    </header>
  );
};
